import Cookies from 'js-cookie'

export default () => {
  const popup = document.querySelector('.js-fullscreen-popup')
  if (!popup) return
  const close = popup.querySelector('.js-fullscreen-popup-close')
  const cta = popup.querySelector('.js-fullscreen-popup-cta')
  // const container = popup.querySelector('.js-fullscreen-popup-container')

  window.setTimeout(() => {
    popup.classList.remove('inactive')
  }, 5000)

  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      closePopup()
    }
  })

  close.addEventListener('click', () => {
    closePopup()
  })

  cta.addEventListener('click', () => {
    closePopup()
  })

  function closePopup() {
    try {
      popup.parentNode.removeChild(popup)
      Cookies.set('bronkhorst_closed_fullscreen_popup', 1, { expires: 14 })
    } catch (error) {
      console.log(error)
      window.location.reload()
      Cookies.set('bronkhorst_closed_fullscreen_popup', 1, { expires: 14 })
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/FullscreenPopup.js